/* ===== Show More Details - Country Road Style ===== */
(function() {
  'use strict';

  var COLLAPSED_HEIGHT = 120;
  var PLUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
  var MINUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line></svg>';

  function setupDescriptionPanel(descContainer) {
    if (descContainer.querySelector('.norsu-details-content')) return;

    var originalMaxHeight = descContainer.style.maxHeight;
    var originalOverflow = descContainer.style.overflow;

    descContainer.style.maxHeight = '10000px';
    descContainer.style.overflow = 'hidden';
    var contentHeight = descContainer.scrollHeight;
    descContainer.style.maxHeight = originalMaxHeight;
    descContainer.style.overflow = originalOverflow;

    if (contentHeight <= COLLAPSED_HEIGHT) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'norsu-details-content is-collapsed';

    while (descContainer.firstChild) {
      wrapper.appendChild(descContainer.firstChild);
    }
    descContainer.appendChild(wrapper);

    var btnWrap = document.createElement('div');
    btnWrap.className = 'norsu-show-more-wrap';

    var showMoreBtn = document.createElement('button');
    showMoreBtn.className = 'norsu-show-more-btn';
    showMoreBtn.setAttribute('aria-expanded', 'false');
    showMoreBtn.type = 'button';
    showMoreBtn.innerHTML = 'Show more details ' + PLUS_SVG;

    btnWrap.appendChild(showMoreBtn);
    descContainer.appendChild(btnWrap);

    var isExpanded = false;

    showMoreBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      isExpanded = !isExpanded;

      if (isExpanded) {
        wrapper.classList.remove('is-collapsed');
        wrapper.classList.add('is-expanded');
        showMoreBtn.innerHTML = 'Show less details ' + MINUS_SVG;
        showMoreBtn.setAttribute('aria-expanded', 'true');
      } else {
        wrapper.classList.remove('is-expanded');
        wrapper.classList.add('is-collapsed');
        showMoreBtn.innerHTML = 'Show more details ' + PLUS_SVG;
        showMoreBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initShowMoreDetails() {
    var descContainers = document.querySelectorAll('.product__decription-container');
    descContainers.forEach(function(container) {
      setupDescriptionPanel(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowMoreDetails);
  } else {
    initShowMoreDetails();
  }

  document.addEventListener('shopify:section:load', initShowMoreDetails);

})();